var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('The404',[_c('h1',{staticClass:"mx-auto"},[_vm._v("No Recipe Found")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }